export default "__VITE_ASSET__B6V3dnEs__"